export const ACTION_INIT_DATA__REQUEST = 'ACTION_INIT_DATA__REQUEST';
export const ACTION_INIT_DATA__SUCCESS = 'ACTION_INIT_DATA__SUCCESS';
export const ACTION_INIT_DATA__FAIL = 'ACTION_INIT_DATA__FAIL';
